export interface ZeusAPINewCardRequest {
    tokenKey: string;
    externalId: string;
    amount: number;
    count: string;
}

export interface ZeusAPIKnownCardRequest {
    externalId: string;
    amount: number;
    count: string;
}

export interface PostBodyZeusAPI {
    "@_service": string;
    "@_action": string;
    authentication: { clientip: string; key: string };
    token_key?: string;
    card?: { history: { key: string } };
    payment: {
        amount: number;
        count: string;
    };
    uniq_key: { sendid: string };
    print_am: string;
    print_addition_value: string;
}

export interface ResponseTokenZeusAPI {
    status: string;
    code?: string;
    message?: string;
    tokenKey: string;
    maskedCvv: string;
    maskedCardNumber: string;
    cardExpiresMonth: string;
    cardExpiresYear: string;
}

// export interface BodyPostPaymentCreditCardZeus {
//     tokenKey: string;
//     changeCard?: boolean;
//     orderedAmount?: number;
// }

// export interface ParamsPaymentCreditCardZeus {
//     tokenKey: string;
//     externalId?: string;
//     amount: number;
//     count: string;
//     email?: string;
//     changeCard?: boolean;
// }

export interface ResponseZeusAPI {
    status: PaymentStatus;
    code: string;
    message?: string;
    orderNumber?: string;
    cardNumberSuffix?: string;
    expiresYear?: string;
    expiresMonth?: string;
    sendid?: string;
}

// export interface ResponseGetEntityUser {
//     userId: string;
//     externalId: string;
//     isPaid: boolean;
//     email: string;
// }

// export interface ParamsCreateEntityPayments {
//     isAuthority: boolean;
//     changeCard: boolean;
//     nowDate: Date;
//     userId: string;
//     externalId: string;
//     amount: number;
//     cardNumberSuffix?: string;
//     expiresYear?: string;
//     expiresMonth?: string;
//     firstPaymentDate: string;
//     status: string;
//     code: string;
//     message?: string;
//     orderNumber?: string;
// }

// export interface MemberStatus {
//     isPaid: boolean;
//     amount: number;
// }

export interface CreditCard {
    cardNumber: string;
    expiresYear: string;
    expiresMonth: string;
    securityNo: string;
}

// export interface PaidContractAddress {
//     zip: string;
//     prefecture: string;
//     city: string;
//     address: string;
//     building: string;
// }

export const PAYMENT_COMPANY = "ZEUS";
export const PAYMENT_COUNT = "01";

// NOTE: 並び替えはしない
export enum PaymentPlanId {
    Default = 1,
    Test1 = 2,
    Test2 = 3,
    Test3 = 4,
    Release = 5,
    Test4 = 6,
    Spring1 = 7,
    Spring2 = 8,
    may2021 = 9,
    June2021 = 10,
    July2021 = 11,
    Aug2021 = 12,
    LaterAug2021 = 13,
    Sep2021 = 14,
    Oct2021 = 15,
    Nov2021 = 16,
    LaterNov2021 = 17,
    LastNov2021 = 18
}

export enum PaymentType {
    First = 1, // 初回決済前
    Repeat // 初回決済後
}

export enum PaymentTransactionType {
    AppCardAuth = 1, // アプリからカードオーソリ
    AppPayment = 2, // アプリ、Webで決済
    AppApplyStopPaid = 3, // アプリで無料化申請
    AppApplyRestartPaid = 4, // アプリで再度更新申請
    BatchStopPaid = 5, // バッチ処理で無料会員化
    BatchChargePayment = 6, // バッチ処理で決済
    BatchForceStopPaid = 7, // バッチ処理で強制無料会員化
    WebCardAuth = 8 // Webからカードオーソリ
}

export enum PaymentStatus {
    Success = "success", // トークン発行/オーソリ成功
    Failure = "failure", // トークン発行/オーソリ失敗
    Invalid = "invalid", // パラメータ値エラー
    Maintenance = "maintenance" // 処理失敗
}

// export const ERROR_CODE_CREDIT_CARD: { id: string; text: string }[] = [
//     { id: "005", text: "" },
//     { id: "006", text: "" },
//     { id: "007", text: "" },
//     { id: "008", text: "" },
//     { id: "013", text: "" },
//     { id: "025", text: "" },
//     { id: "026", text: "" },
//     { id: "028", text: "" },
//     { id: "038", text: "" },
//     { id: "041", text: "" },
//     { id: "052", text: "" }
// ];

export const ERROR_MESSAGE_DEFAULT =
    "こちらのクレジットカードはご利用できません";

export const ERROR_MESSAGE_TOKEN: { id: string; text: string }[] = [
    { id: "88888888", text: "メンテナンス中です" },
    { id: "99999999", text: "その他のシステムエラーが発生しました" },
    { id: "02030209", text: "XML データに構文エラーがある" },
    { id: "02130514", text: "「カード番号」を入力してください" },
    { id: "02130517", text: "「カード番号」を正しく入力してください" },
    { id: "02130619", text: "「カード番号」を正しく入力してください" },
    { id: "02130620", text: "「カード番号」を正しく入力してください" },
    { id: "02130621", text: "「カード番号」を正しく入力してください" },
    { id: "02130640", text: "「カード番号」を正しく入力してください" },
    { id: "02130714", text: "「有効期限(年)」を入力してください" },
    { id: "02130717", text: "「有効期限(年)」を正しく入力してください" },
    { id: "02130725", text: "「有効期限(年)」を正しく入力してください" },
    { id: "02130814", text: "「有効期限(月)」を入力してください" },
    { id: "02130817", text: "「有効期限(月)」を正しく入力してください" },
    { id: "02130825", text: "「有効期限(月)」を正しく入力してください" },
    { id: "02130922", text: "「有効期限」を正しく入力してください" },
    { id: "02131014", text: "セキュリティーコードが不正です" },
    { id: "02131017", text: "「セキュリティコード」を正しく入力してください" },
    { id: "02131117", text: "「カード名義」を正しく入力してください" },
    { id: "02131123", text: "「カード名義」を正しく入力してください" },
    { id: "02131124", text: "「カード名義」を正しく入力してください" }
];

export const ERROR_MESSAGE_PAYMENT_FAILURE: { id: string; text: string }[] = [
    {
        id: "005",
        text: "一時的な理由により、カード利用不可の状態となっています"
    },
    { id: "006", text: "無効なカードです。" },
    { id: "007", text: "有効期限が誤っています。" },
    { id: "012", text: "不正IP" },
    { id: "013", text: "一時不正IP" },
    { id: "016", text: "決済停止" },
    { id: "021", text: "電話不正" },
    { id: "024", text: "支払不正分割回数" }
];

export const ERROR_MESSAGE_PAYMENT_INVALID: { id: string; text: string }[] = [
    { id: "02030209", text: "XML データに構文エラーがある" },
    { id: "02131914", text: "トークンが無効です" }
];

export const ERROR_MESSAGE_PAYMENT_MAINTENANCE: {
    id: string;
    text: string;
}[] = [
    { id: "01001", text: "カード会社決済処理センターメンテナンス" },
    { id: "02090332", text: "ACSが障害中など様々な理由" }
];

// export const getMatchErrorCodeCreditCard = (id: string): boolean => {
//     return ERROR_CODE_CREDIT_CARD.find((v) => v.id.toString().slice(-3) === id) ? true : false;
// };

export const getErrorMessageToken = (id: string): string => {
    return id
        ? ERROR_MESSAGE_TOKEN.find(v => v.id === id)?.text
        : ERROR_MESSAGE_DEFAULT;
};

export const getErrorMessagePayment = (status: string, id: string): string => {
    switch (status) {
        case PaymentStatus.Failure:
            return id
                ? ERROR_MESSAGE_PAYMENT_FAILURE.find(v => v.id === id)?.text
                : ERROR_MESSAGE_DEFAULT;
        case PaymentStatus.Invalid:
            return id
                ? ERROR_MESSAGE_PAYMENT_INVALID.find(v => v.id === id)?.text
                : ERROR_MESSAGE_DEFAULT;
        case PaymentStatus.Maintenance:
            return id
                ? ERROR_MESSAGE_PAYMENT_MAINTENANCE.find(v => v.id === id)?.text
                : ERROR_MESSAGE_DEFAULT;
        default:
            return null;
    }
};
